var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.553,
    height: 63.553,
    viewBox: "0 0 63.553 63.553",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.495,1.805A31.777,31.777,0,1,0,65.271,33.582,31.777,31.777,0,0,0,33.495,1.805ZM14.743,52.414c9.615-10.312,28.1-10.3,37.444-.054C43.585,62.324,25.014,63.443,14.743,52.414Zm9.03-22.492a9.721,9.721,0,0,1,19.442.1,9.721,9.721,0,0,1-19.442-.1Zm31.7,18.607a33.359,33.359,0,0,0-12.362-7.388c7.462-7.293,5.63-16.936.416-21.806a14.692,14.692,0,0,0-20.178.109c-5.156,4.91-6.866,14.471.4,21.562-2.156,1.051-4.4,1.967-6.449,3.194s-3.934,2.77-5.891,4.175c-6.427-8.42-7.052-23.989,3.68-34.223a26.845,26.845,0,0,1,36.7-.11C62.6,24.219,62.081,39.816,55.475,48.529Z",
    transform: "translate(-1.718 -1.805)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProf);
export default __webpack_public_path__ + "static/media/prof.66d8dfbf81801c6c9fa99fdb29fcc4d0.svg";
export { ForwardRef as ReactComponent };